import { transition } from "@codesandbox/states";

import type { State, Action } from "./types";

export const reducer = (prevState: State, action: Action) =>
  transition(prevState, action, {
    CONNECTING: {
      "PITCHER:CONNECTED": ({ shellId }) => ({
        state: "INITIALIZING",
        shellId,
      }),
      "PITCHER:ERROR": (_, { error }) => ({
        state: "ERROR",
        context: {
          event: "PITCHER:ERROR",
          state: "CONNECTING",
        },
        error,
      }),
    },
    INITIALIZING: {
      "PITCHER:SHELL:OPEN_SUCCESS": (state, { shell }) =>
        state.shellId === shell.shellId
          ? {
              state: "READY",
              id: shell.shellId,
              buffer: shell.buffer,
              name: shell?.name || null,
              ownerUsername:
                shell.shellType === "TERMINAL"
                  ? shell.ownerUsername
                  : undefined,
            }
          : state,
      "PITCHER:SHELL:OPEN_ERROR": (_, { error }) => ({
        state: "ERROR",
        context: {
          event: "PITCHER:SHELL:OPEN_ERROR",
          state: "OPENING",
        },
        error,
      }),
    },
    READY: {
      PATH_CLICK: (state) => ({
        ...state,
      }),
      URL_CLICK: (state) => ({
        ...state,
      }),
      "PITCHER:SHELL:RENAME": (state, { shellId, name }) => {
        if (state.id !== shellId) {
          return state;
        }

        return {
          ...state,
          name: name,
        };
      },
    },
    ERROR: {},
  });
